<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="#adadad" fill-rule="evenodd" d="M7.922 3.498a.924.924 0 1 1-.923.924.924.924 0 0 1 .923-.924zM8-.002a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm1.27 11.064h-.635v-4.3a.616.616 0 0 0-.616-.615H6.8a.616.616 0 0 0 0 1.231h.605v3.7H6.77a.615.615 0 1 0 0 1.23h2.5a.615.615 0 0 0 0-1.23z"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-info-solid',
});
</script>
